var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#group--security_svg__clip0_61530_7281)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.75h-1.5v-1.5A2.253 2.253 0 019 12h4.5v1.5H9a.75.75 0 00-.75.75v1.5zM11.25 11.25a3 3 0 110-6 3 3 0 010 6zm0-4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 16.5a3 3 0 110-5.999 3 3 0 010 5.999zm0-4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM22.5 21H21v-1.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 00-.75.75V21h-1.5v-1.5a2.253 2.253 0 012.25-2.25h4.5a2.253 2.253 0 012.25 2.25V21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.8l-3.926-2.093A6.74 6.74 0 013 12.75V3h15v4.5h1.5V3A1.502 1.502 0 0018 1.5H3A1.502 1.502 0 001.5 3v9.75a8.236 8.236 0 004.368 7.28L10.5 22.5v-1.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "group--security_svg__clip0_61530_7281"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgGroupSecurity;